import React from "react";
import { useForm } from "react-hook-form";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { FormControl } from "@mui/material";
import { InputLabel } from "@mui/material";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import { Button } from "@mui/material";
import { useGetChannelConnections } from "hooks/useGetChannelConnections";

interface AutomationCreateFormProps {
  onSubmit: (data: any) => void;
}

export const AutomationCreateForm = ({ onSubmit }: AutomationCreateFormProps) => {
  const { data: channelConnections } = useGetChannelConnections({ platform: "INSTAGRAM" });
  const {
    register,
    handleSubmit,
    control,
    formState: { isValid },
  } = useForm();

  return (
    <div>
      <h3>Новая автоматизация</h3>
      <p>Будет размещена в "Все автоматизации"</p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-4">
          <TextField
            label="Название"
            {...register("name", { required: true })}
            required
            fullWidth
          />
        </div>
        <div className="mb-4">
          <Controller
            control={control}
            name="channelConnectionID"
            rules={{ required: true }}
            render={({ field }) => (
              <FormControl fullWidth>
                <InputLabel shrink>Аккаунт</InputLabel>
                <Select
                  label="Аккаунт"
                  {...field}
                  required
                  fullWidth
                  inputProps={{
                    shrink: true,
                  }}
                >
                  {channelConnections?.length > 0 &&
                    channelConnections
                      ?.filter(
                        (channelConnection: any) =>
                          channelConnection.source === "INSTAGRAM" &&
                          channelConnection.externalAccountUserName
                      )
                      ?.map((channelConnection: any) => (
                        <MenuItem key={channelConnection.id} value={channelConnection.id}>
                          {channelConnection.externalAccountUserName}
                        </MenuItem>
                      ))}
                </Select>
              </FormControl>
            )}
          />
        </div>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          className="mt-4"
          disabled={!isValid}
        >
          Создать
        </Button>
      </form>
    </div>
  );
};
